<template>
  <v-card class="red">
    <v-card-title primary-title>
      Fiche calculée à partir de saisie par Opérateur de saisie
    </v-card-title>
    <v-card-text>
      <v-card
        class="elevation-1 pa-2 ma-2 rounded blue-grey lighten-5"
        v-for="(detailEtape, index) in detailEtapes"
        :key="index"
      >
        <v-card-text>
          <div v-if="detailEtape.type_champ == 0">
            {{ detailEtape.ll_details_etapes }}   <!-- {{ detailEtape.rangDetailEtape }} -->
            <!--  {{ detailEtape.typeChamp }} -->
            <v-simple-table>
              <thead>
                <tr>
                  <td>
                    Nombre de Femmes
                  </td>
                  <td>
                    Nombre d'Hommes
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr class="elevation-1 pa-2 ma-2 rounded">
                  <td class="pa-5">
                    <v-text-field
                      disabled
                      outlined
                      type="number"
                      v-model="detailEtape.valueRecapFemmes"
                    ></v-text-field>
                  </td>
                  <td class="pa-5">
                    <v-text-field
                      disabled
                      outlined
                      type="number"
                      v-model="detailEtape.valueRecapHommes"
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div v-else-if="detailEtape.type_champ == 1">
            {{ detailEtape.ll_details_etapes }}   <!-- {{ detailEtape.rangDetailEtape }} -->
            <!--  {{ detailEtape.typeChamp }} -->
            <v-simple-table>
              <tbody>
                <tr class="elevation-1 pa-2 ma-2 rounded blue-grey lighten-5">
                  <td class="pa-5">
                    <v-text-field
                      disabled
                      :label="detailEtape.ll_details_etapes"
                      type="number"
                      v-model="detailEtape.valueCalcul"
                    ></v-text-field>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div v-else-if="detailEtape.type_champ == 2">
            {{ detailEtape.ll_details_etapes }}   <!-- {{ detailEtape.rangDetailEtape }} -->
            <!--  {{ detailEtape.typeChamp }} -->
            <v-simple-table>
              <tbody>
                <tr class="elevation-1 pa-2 ma-2 rounded blue-grey lighten-5">
                  <td class="pa-5">
                    <v-text-field disabled outlined type="text"  v-model="detailEtape.valueNombreMembre"></v-text-field>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  components: {
    //fiche: require("@/components/fiche.vue").default,
  },
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    detailEtapes: { type: Array, required: true },
    etapeEffective: { type: Object, required: true },
  },
  methods: {
    saveWholeObject(payload) {},
  },
};
</script>

<style lang="scss" scoped></style>
